import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as rxjs from 'rxjs'

import * as gql from './gql'

/** TODO:  */
@ngCore.Injectable()
export class Api {
  /** TODO:  */
  public generate(
    { tenantId, zoneId }: ents.core.admin.Context.ForZone,
    { prompt, fileData }: Api.generate.Request,
  ) {
    return gql.mutations.generateMosaicPage.executor({
      data: JSON.stringify(fileData),
      prompt,
      tenantId,
      zoneId,
    })
  }
}
export namespace Api {
  export namespace generate {
    export interface Request {
      prompt: string
      fileData?: Record<string, string>
    }
  }
}
